import React, {useState, useEffect, useRef} from "react";

// react-router components
import {useLocation, Link, useNavigate, NavLink} from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
// import {
//   setTransparentNavbar,
//   setMiniSidenav,
//   setOpenConfigurator,
// } from "context";
import { useDispatch, useSelector } from "react-redux";
import {
  Logout,
  onSuccessAlert,
  setLanguage,
  setMiniSidenav,
  setOpenConfigurator,
  setTransparentNavbar
} from "../../../actions";
import {createTheme, styled, ThemeProvider} from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import {
  Dialog, DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, FormControl,
  FormControlLabel,
  FormGroup, FormHelperText,
  InputAdornment, Select
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import MDTypography from "../../../components/MDTypography";
import LocalStorage from "../../../utils/LocalStorage";
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import PaperComponent from "../../../components/MuiDraggableDialog";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import adminRoutes from "../../../adminRoutes";
import colors from "assets/theme/base/colors";
import {tabsRoutes} from "../../../constants";
import MDButton from "../../../components/MDButton";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import MenuItem from "@mui/material/MenuItem";
import LanguageIcon from '@mui/icons-material/Language';

const muiTheme = createTheme({
  slider: {
    trackColor: "yellow",
    selectionColor: "green"
  }
});

function DashboardNavbar({ absolute, light, isMini }) {
  const languageList = [
    {
      id: 1,
      label: 'En',
      lang:'en',
      value: 1
    },
    {
      id: 2,
      label: '中文',
      lang:'zh',
      value: 2
    },
    {
      id: 3,
      label: 'Fr',
      lang:'fr',
      value: 3
    },
  ]
  const [navbarType, setNavbarType] = useState();
  const nav = useNavigate()
  const dispatch = useDispatch()
  const [openMenu, setOpenMenu] = useState(false);
  const [openAccount , setOpenAccount] = useState(false)
  const [openSupport , setOpenSupport] = useState(false)
  const [openHelpCenter , setOpenHelpCenter] = useState(false)
  const route = useLocation().pathname.split("/").slice(1);
  const fixedNavbar = useSelector(state => state?.common?.fixedNavbar)
  const miniSidenav = useSelector(state => state?.common?.miniSidenav)
  const transparentNavbar = useSelector(state => state?.common?.transparentNavbar)
  const sidenavColor = useSelector(state => state?.common?.sidenavColor)
  const openConfigurator = useSelector(state => state?.common?.openConfigurator)
  const darkMode = useSelector(state => state?.common?.darkMode)
  const language = useSelector(state => state?.common?.language)
  const [searchHistory, setSearchHistory] = useState([]);
  const [searchValue, setSearchValue] = useState("")
  const { t, i18n } = useTranslation();
  const [filteredList , setFilteredList] = useState([]);
  const [languageSelect ,setLanguageSelect] = useState(languageList.find((lang)=>lang.lang === i18n.language).value);
  const [openLanguageSelect,setOpenLanguageSelect] = useState(false);

  useEffect(() => {
    // 确保语言在组件加载时同步
    const language = i18n.language || 'en'; // 默认语言是 'en'
    setLanguageSelect(languageList.find((lang) => lang.lang === language)?.value );
  }, [i18n.language]);

  useEffect(() => {
    const currentSearchHistory = LocalStorage.getItem("searchHistory")
        ? JSON.parse(LocalStorage.getItem("searchHistory"))
        : [];
    setSearchHistory(currentSearchHistory);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // 检测 Command + K 或 Ctrl + K
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault(); // 阻止默认行为（如浏览器快捷键）
        setSearchValue("")
        setOpenHelpCenter((prev) => !prev); // 切换搜索状态
      }
    };

    // 绑定事件监听
    window.addEventListener("keydown", handleKeyDown);

    // 清理事件监听
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  function extractItems(list, keys, parentRoute = "") {
    const result = [];

    list.forEach((item) => {
      const currentRoute = parentRoute + item.route;

      // 如果当前元素符合条件，添加到结果中
      if (keys.includes(item.key) && !item.children) {
        result.push({ ...item, route: currentRoute }); // 拼接父级路由
      }

      // 如果有 children，递归调用函数
      if (item.children) {
        result.push(
            ...extractItems(item.children, keys, currentRoute) // 递归传递当前的路由作为父级路由
        );
      }
    });
    return result;
  }
  // const filteredList = [...extractItems(adminRoutes, menuList), ...tabsRoutes];

  const menuList = JSON.parse(LocalStorage.getItem('keys'))
  useEffect(() => {
    setFilteredList([...extractItems(adminRoutes, menuList), ...tabsRoutes()]);
  },[openHelpCenter])

  const getSearchHistoryList = () => {
    const currentSearchHistory = LocalStorage.getItem("searchHistory")
        ? JSON.parse(LocalStorage.getItem("searchHistory"))
        : [];

    // 按 currentSearchHistory 的顺序生成列表
    return currentSearchHistory
        .map(key => filteredList.find(item => item.key === key)) // 按顺序查找
        .filter(Boolean); // 去掉 undefined 的项（即不存在于 filteredList 的项）
  };

  const filteredSearchList = getSearchHistoryList()

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      dispatch(setTransparentNavbar((fixedNavbar && window.scrollY === 0) || !fixedNavbar))
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => dispatch(setMiniSidenav( !miniSidenav))
  const handleConfiguratorOpen = () => dispatch(setOpenConfigurator( !openConfigurator))

  const handleToggleLanguage = () => {
    // if(language === 'en'){
    //     dispatch(setLanguage('zh'))
    //     i18n.changeLanguage('zh')
    // } else {
    //     dispatch(setLanguage('en'))
    //     i18n.changeLanguage('en')
    // }
    if (language === 'en') {
      dispatch(setLanguage('zh'));
      i18n.changeLanguage('zh');
    } else if (language === 'zh') {
      dispatch(setLanguage('fr'));
      i18n.changeLanguage('fr');
    } else {
      dispatch(setLanguage('en'));
      i18n.changeLanguage('en');
    }
  }

  const handleOpenHelpCenter = (event) => setOpenHelpCenter(event.currentTarget);

  const handleCloseHelpCenter = () => {
    setSearchValue("")
    setOpenHelpCenter(false)
  };

  const handleOpenAccount = (event) => setOpenAccount(event.currentTarget);

  const handleCloseAccount = () => setOpenAccount(false);

  const handleOpenSupport = (event) => setOpenSupport(event.currentTarget);

  const handleCloseSupport = () => setOpenSupport(false);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  const onLogOutSuccess = (msg) => {
    dispatch(onSuccessAlert(t(msg)))
    nav('/authentication/sign-in')
  }

  const handleLogout = () => {
    dispatch(Logout(onLogOutSuccess))
  }

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  const renderAccount = () => (
      <Menu
      anchorEl={openAccount}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openAccount)}
      onClose={handleCloseAccount}
      sx={{ mt: 2 }}
  >
    <NotificationItem onClick={handleLogout} icon={<Icon>logout</Icon>} title={t("Log Out")}/>
  </Menu>)

  // const renderSupport = () => (
  //     <Menu
  //         anchorEl={openSupport}
  //         anchorReference={null}
  //         anchorOrigin={{
  //           vertical: "bottom",
  //           horizontal: "left",
  //         }}
  //         open={Boolean(openSupport)}
  //         onClose={handleCloseSupport}
  //         sx={{ mt: 2 }}
  //     >
  //       <NotificationItem onClick={() => window.open('https://darwynnfulfillment.freshdesk.com', '_blank')} icon={<Icon>support_agent</Icon>} title="Ticket System" />
  //       <NotificationItem onClick={() => window.open('https://darwynndispatch.freshdesk.com', '_blank')} icon={<Icon>calendar_today</Icon>} title="Schedule LTL/FTL" />
  //     </Menu>)

  const renderHelpCenter = () => {
    const inputRef = useRef(null); // 创建引用

    useEffect(() => {
      if (openHelpCenter) {
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // 等待下一个事件循环
      }
    }, [openHelpCenter]); // 监听 openHelpCenter 的变化

    const getSearchResult = () =>{
        return filteredList?.filter((v)=>v.chineseName.includes(searchValue.trim())
            || v.name.toLowerCase().includes(searchValue.trim().toLowerCase())
            || v.key?.replace(/[^a-zA-Z0-9]/g, "").toLowerCase().includes(searchValue.trim().toLowerCase())
        )
    }

    return  <Dialog
        open={openHelpCenter}
        onClose={handleCloseHelpCenter}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        scroll={'paper'}
        fullWidth={true}
        // maxWidth={'md'}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start", // 强制顶部对齐
          },
          "& .MuiDialog-paper": {
            marginTop: "20px", // 距离顶部的间距
            minWidth: "600px",
            minHeight: "150px",
            "@media (max-width: 600px)": {
              minWidth: "90%", // 移动端填满屏幕宽度
            },
            maxHeight: "600px",
          },
        }}
        TransitionProps={{
          onEntered: () => {
            if (inputRef.current) {
              inputRef.current.focus();
            }
          },
        }}
        disableAutoFocus
        disableEnforceFocus
    >
      <DialogTitle style={{ cursor: 'move', display: 'flex', justifyContent: 'space-between' ,paddingBottom:"0px"}}
                   id="draggable-dialog-title">
        <MDBox sx={{display:"flex", alignItems:"center", width: '100%',}}>
          <SearchIcon fontSize={"medium"} sx={{marginRight:"10px"}}/> {/* 设置图标大小 */}
          <TextField
              id="input-with-icon-textfield"
              placeholder={t("HelpCenter.What are you looking for?")}
              variant="standard"
              name={`unique-name-${Math.random().toString(36).substr(2, 9)}`} // 动态生成唯一的 name
              autoComplete="off" // 禁用自动填充
              inputProps={{
                autoComplete: "new-password", // 更强制的禁用方式，避免某些浏览器忽略 "off"
              }}
              value={searchValue}
              onChange={(event) => {
                setSearchValue(event.target.value)
              }}
              inputRef={inputRef} // 绑定输入框引用
              sx={{
                width: '100%',
                "& .MuiInputBase-input": {
                  fontSize: "20px", // 设置输入文字大小
                },
                "& .MuiInput-underline:before": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottom: "none",
                },
              }}
          />
        </MDBox>
        <IconButton size="medium" onClick={handleCloseHelpCenter}>
          <Icon>cancel</Icon>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Divider />
          <MDBox pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
            <MDBox sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%'}}>
              {
                  searchValue === "" && filteredSearchList.length >0&&
                  <MDBox>
                    <MDBox mb={2}>
                    <MDTypography variant="h6" fontWeight="medium">
                      {t("HelpCenter.Recent")}
                    </MDTypography>
                    </MDBox>

                    <Grid container spacing={1}>
                      {
                        filteredSearchList?.reverse().map((item, index) => {
                          return (
                              <Grid key={item.route} pb={0} item xs={12} md={12} mb={1} sx={{minWidth: 300,width: '100%'}}>
                                <NavLink
                                    to={`/app${item.route}`}
                                    onClick={() => {
                                      if (item.type === "tab")
                                      {
                                        localStorage.setItem(item.localStorageKey.key,item.localStorageKey.value)}                                      let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                      let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                      newSearchHistory.push(item.key);
                                      newSearchHistory = newSearchHistory.slice(-5);
                                      LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                      handleCloseHelpCenter()
                                    }}
                                >
                                  <MDBox pl={1} sx={{display: "flex", justifyContent: "space-between",
                                    ":hover": {
                                      backgroundColor: darkMode ? "#3e3e3e" : "#f0f0f0", // 背景高亮色
                                      borderRadius: "8px", // 可选：增加圆角
                                      transition: "background-color 0.3s ease" // 平滑过渡效果
                                    } }}>
                                    <MDBox sx={{display: "flex",alignItems: "center"}}>
                                      <MDTypography  sx={{display: "flex",alignItems: "center"}}>
                                        <Icon fontSize="medium">history</Icon>
                                      </MDTypography>
                                      {/*<MDBox sx={{display: "flex",alignItems: "center"}}>*/}
                                      {/*  {item.icon}*/}
                                      {/*</MDBox>*/}
                                      <MDBox >
                                        <MDBox ml={2} sx={{display: "flex",flexDirection: "column",alignItems: "flex-start"}}>
                                          <MDTypography >
                                            { i18n.language === "zh" ? item.chineseName : item.name}
                                          </MDTypography>
                                          <MDTypography sx={{fontSize:"14px"}}>
                                            {item.parent? ( i18n.language === "zh" ? item.chineseNameParent : item.parent) :( i18n.language === "zh" ? "目录" : "Menu")}
                                          </MDTypography>
                                        </MDBox>
                                      </MDBox>
                                    </MDBox>
                                    <MDBox sx={{display:"flex",flexDirection: "row",alignItems: "center"}} mr={2}>
                                      <MDTypography>
                                        <Icon onClick={(e) => {
                                          e.preventDefault()
                                          e.stopPropagation()
                                          let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                          let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                          setSearchHistory(newSearchHistory); // 更新状态
                                          LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                        }}>
                                          clear
                                        </Icon>
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>
                                </NavLink>
                              </Grid>
                          )
                        })
                      }
                    </Grid>
                  </MDBox>
              }
              {
                  searchValue !== "" && getSearchResult()?.length > 0
                  &&
                  <Grid container spacing={1}>
                    {
                      getSearchResult()?.map((item, index) => {
                        return (
                            <Grid pb={0} key={item.route}  item xs={12} md={12} mb={1} sx={{minWidth: 300,width: '100%'}}>
                              <NavLink to={`/app${item.route}`}
                                       onClick={()=>{
                                         if (item.type === "tab")
                                         {
                                           localStorage.setItem(item.localStorageKey.key,item.localStorageKey.value)}
                                         let currentSearchHistory = LocalStorage.getItem("searchHistory") ? JSON.parse(LocalStorage.getItem("searchHistory")) : []
                                         let newSearchHistory = currentSearchHistory.filter((e)=>e !== item.key)
                                         newSearchHistory.push(item.key);
                                         newSearchHistory = newSearchHistory.slice(-5);
                                         setSearchHistory(newSearchHistory);
                                         LocalStorage.setItem("searchHistory", JSON.stringify(newSearchHistory));
                                         handleCloseHelpCenter()
                                       }}
                              >
                                <MDBox pl={1} sx={{display: "flex" ,justifyContent: "space-between",
                                  width: '100%',
                                  ":hover": {
                                    backgroundColor: "#f0f0f0", // 背景高亮色
                                    borderRadius: "8px", // 可选：增加圆角
                                    transition: "background-color 0.3s ease" // 平滑过渡效果
                                  }

                                }}>
                                  <MDBox sx={{display: "flex",alignItems: "center",}}>
                                    <MDTypography sx={{display: "flex",alignItems: "center"}}>
                                      {item.icon}
                                    </MDTypography>
                                    <MDBox ml={2} sx={{display: "flex",flexDirection: "column",alignItems: "flex-start"}}>
                                      <MDTypography >
                                        { i18n.language === "zh" ? item.chineseName : item.name}
                                      </MDTypography>
                                      <MDTypography sx={{fontSize:"14px"}}>
                                        {item.parent? ( i18n.language === "zh" ? item.chineseNameParent : item.parent) :( i18n.language === "zh" ? "目录" : "Menu")}
                                      </MDTypography>
                                    </MDBox>
                                  </MDBox>
                                </MDBox>
                              </NavLink>
                            </Grid>
                        )
                      })
                    }
                  </Grid>
              }
              {
                  searchValue !== "" && (getSearchResult()?.length ===0)
                  &&
                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} md={12} mb={2} sx={{minWidth: 300 }}>
                      <MDBox sx={{display: "flex" ,justifyContent: "center", }}>
                        <MDTypography>
                          <Icon fontSize="medium">search_off</Icon>
                          {/*<SearchOffIcon fontSize={'medium'} />*/}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{display: "flex" ,justifyContent: "center", }}>
                        <MDTypography>
                          No results for "{searchValue}"
                        </MDTypography>
                      </MDBox>
                    </Grid>
                  </Grid>
              }
            </MDBox>
          </MDBox>
        </DialogContentText>
        <DialogActions>
          <MDTypography
              variant="body2"
              sx={{
                marginRight: 2,
                fontSize: '0.75rem',
                color: '#333', // 字体颜色更深，模拟按键上的文本
                // backgroundColor: '#f4f4f4', // 更接近键盘的浅灰背景
                padding: '2px 8px', // 稍微加宽
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // 添加阴影，增加立体感
                textAlign: 'center',
                whiteSpace: 'nowrap', // 防止文本换行
                letterSpacing: '0.5px', // 增加字母间距，增强键盘效果
              }}
          >
            Ctrl + K
          </MDTypography>
            {t("HelpCenter.to close")}
        </DialogActions>
      </DialogContent>
    </Dialog>
  }


  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }
      return colorValue;
    },
  });

  const handleLanguageSelectChange = (event) => {
    dispatch(setLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang));
    i18n.changeLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang);
    setLanguageSelect(event.target.value);
  };
  const handleLanguageSelectClose = () => {
    setOpenLanguageSelect(false);
  };

  const handleLanguageSelectOpen = () => {
    setOpenLanguageSelect(true);
  };

  return (
    <AppBar
        id={'appBar'}
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <IconButton
              size="small"
              disableRipple
              color="inherit"
              sx={navbarMobileMenu}
              onClick={handleMiniSidenav}
          >
            <Icon sx={iconsStyle} fontSize="medium">
              {miniSidenav ? "menu" : "menu_open"}
            </Icon>
          </IconButton>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox>
        <ThemeProvider theme={muiTheme}>
          <Button size="small" variant="outlined"
                  sx={{
                    // marginRight: "20px",
                    borderWidth: '2px',
                    borderColor: colors.gradients[sidenavColor].main,   //'#7B809A', // 设置边框颜色为灰色
                    color: '#7B809A', // 设置文本颜色为灰色
                    borderRadius: '10px',
                    '&:hover': {
                      borderColor: colors.gradients[sidenavColor].state, //'darkgray',  // 悬停时边框颜色
                      backgroundColor: 'rgba(128, 128, 128, 0.1)', // 悬停时背景透明灰
                    },
                  }}
                  onClick={handleOpenHelpCenter}
                  startIcon={<SearchIcon />}>
            <MDBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <MDTypography
                  variant="body2"
                  sx={{
                    marginRight: 9,
                    '@media (max-width: 412px)': {
                      display: 'none',  // 在窄屏时隐藏
                    },
                  }}
              >
                  {t("HelpCenter.Search")}
              </MDTypography>
              <MDTypography
                  variant="body2"
                  sx={{
                    display: 'none', // 默认不显示
                    '@media (max-width: 412px)': {
                      display: 'inline', // 在窄屏时显示简短文本
                      fontSize: '0.75rem',
                    },
                  }}
              >
                Search...
              </MDTypography>
              {/*<MDTypography variant="body2" sx={{ marginRight: 9 }}>*/}
              {/*  Search Menus & Tabs...*/}
              {/*</MDTypography>*/}
              <MDTypography
                  variant="body2"
                  sx={{
                    fontSize: '0.75rem',
                    color: '#333', // 字体颜色更深，模拟按键上的文本
                    // backgroundColor: '#f4f4f4', // 更接近键盘的浅灰背景
                    padding: '2px 8px', // 稍微加宽
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    display: 'inline-block',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // 添加阴影，增加立体感
                    textAlign: 'center',
                    whiteSpace: 'nowrap', // 防止文本换行
                    letterSpacing: '0.5px', // 增加字母间距，增强键盘效果
                  }}
              >
                Ctrl + K
              </MDTypography>
            </MDBox>
          </Button>
        </ThemeProvider>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {/*<MDBox pr={1}>*/}
            {/*  <MDInput label="Search here" />*/}
            {/*</MDBox>*/}
            <MDBox color={light ? "white" : "inherit"}>
              {process.env.REACT_APP_LANG_TRANSLATION === 'true' &&
              //     <IconButton
              //   size="small"
              //   disableRipple
              //   color="inherit"
              //   sx={navbarIconButton}
              //   onClick={handleToggleLanguage}
              // >
              //   <Icon sx={iconsStyle}>language</Icon>
              //   {/*{language!=='en'?<span><Typography  fontWeight={'medium'} variant={'caption'} color="secondary">中文</Typography> </span>*/}
              //   {/*    :<Typography  fontWeight={'medium'} variant={'caption'} color="secondary">EN</Typography>*/}
              //   {/*}*/}
              //   {language === 'en' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         中文
              //       </Typography>
              //   )}
              //   {language === 'zh' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         FR
              //       </Typography>
              //   )}
              //   {language === 'fr' && (
              //       <Typography fontWeight={'medium'} variant={'caption'} color="secondary">
              //         EN
              //       </Typography>
              //   )}
              // </IconButton>
                  <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  >
                    <FormControl fullWidth>
                      <Select
                          sx={{
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: 0,
                                },
                          }}
                          open={openLanguageSelect}
                          value={languageSelect}
                          onChange={handleLanguageSelectChange}
                          onClose={handleLanguageSelectClose}
                          onOpen={handleLanguageSelectOpen}
                          renderValue={(value)=>{
                            return(
                                <MDButton sx={{padding:"4px"}} variant={'text'} color="info" startIcon={<LanguageIcon/>} onClick={handleLanguageSelectOpen}>
                                  {languageList.find(v=>v.value === value)?.label || ""}
                                </MDButton>
                            )
                          }}
                      >
                        <MenuItem value={1}>English</MenuItem>
                        <MenuItem value={2}>中文 (Chinese)</MenuItem>
                        <MenuItem value={3}>Français (Canada)</MenuItem>
                      </Select>
                    </FormControl>
                  </IconButton>
              }

              <IconButton sx={navbarIconButton}
                          aria-controls="notification-menu"
                          aria-haspopup="true"
                          variant="contained"
                          disableRipple
                          onClick={handleOpenAccount}
              >
                <Icon sx={iconsStyle}>account_circle</Icon>
                <MDTypography color={'text'} fontWeight={'medium'} variant={'caption'}>{LocalStorage.getItem('sub_username')}</MDTypography>
              </IconButton>

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton>
              {/*<IconButton*/}
              {/*  size="small"*/}
              {/*  disableRipple*/}
              {/*  color="inherit"*/}
              {/*  sx={navbarIconButton}*/}
              {/*  aria-controls="notification-menu"*/}
              {/*  aria-haspopup="true"*/}
              {/*  variant="contained"*/}
              {/*  onClick={handleOpenMenu}*/}
              {/*>*/}
              {/*  <Icon sx={iconsStyle}>notifications</Icon>*/}
              {/*</IconButton>*/}
              {renderMenu()}
              {renderAccount()}
              {/*{renderSupport()}*/}
              {renderHelpCenter()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
